import type { DataSource } from '@/src/renderer/lib/dataSource'
import { isEmptySnapshot } from './format'
import { packForDevice, type PackingBridge } from './packBackup'
import { selectEverything } from './selection'

/**
 * Packt das automatische Backup — oder nichts, wenn HappyTask leer ist (Entscheidung 4): Sonst rotierte
 * ein Datenverlust Tag für Tag die guten Backups weg. Mit Passwort geschützt, wenn eins gesetzt ist.
 */
export async function packAutoBackup(
  dataSource: Pick<DataSource, 'readBackupRows'>,
  accountId: string | null,
  bridge: PackingBridge,
  now: Date = new Date(),
): Promise<Uint8Array | null> {
  const snapshot = await dataSource.readBackupRows({ accountId })
  if (isEmptySnapshot(snapshot.tables)) return null
  return packForDevice({ accountId, profile: snapshot.profile, tables: selectEverything(snapshot.tables) }, bridge, now)
}

/** Das lokale Datum als `JJJJ-MM-TT` — so steht es im Namen eines automatischen Backups. */
export function localDateKey(date: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

/** Teilt die Liste für die Übersicht: eigene der letzten 7 Tage, ältere eigene, die anderer Geräte. */
export function groupAutoBackups<T extends { date: string; own: boolean }>(entries: readonly T[], today: Date = new Date()) {
  const weekAgo = localDateKey(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6))
  const own = entries.filter(entry => entry.own)
  return {
    recent: own.filter(entry => entry.date >= weekAgo),
    older: own.filter(entry => entry.date < weekAgo),
    otherDevices: entries.filter(entry => !entry.own),
  }
}
